// extracted by mini-css-extract-plugin
export default {"wrapper":"PF","subscription":"QF","select_item":"RF","is_selected":"SF","otb":"TF","radio":"UF","first_row":"VF","prices":"WF","italic":"XF","info_wrapper":"YF","first_month":"ZF","separator":"aG","checkmark":"bG","bullets":"cG","bullet":"eG","checkmarkText":"fG","button":"gG","discountBadge":"hG"};
    if(module.hot) {
      // 1721922364403
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  